var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn personPage" },
    [
      !_vm.user.id
        ? _c("div", [
            _c("p", [
              _vm._v(
                "User not found, or you do not have access to this user in the given Org/Group context."
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "h2",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.updateUserPending,
              expression: "updateUserPending"
            }
          ],
          staticClass: "u-padding-bottom-20"
        },
        [_vm._v("Updating, please wait ...")]
      ),
      _vm._v(" "),
      _c("pulse-loader", {
        attrs: {
          loading: _vm.updateUserPending,
          color: _vm.spinnerColor,
          size: _vm.spinnerSize
        }
      }),
      _vm._v(" "),
      _vm.user.id && !_vm.updateUserPending
        ? _c(
            "div",
            [
              _c(
                "b-form",
                { on: { submit: _vm.addOrUpdateUserRecord } },
                [
                  _c(
                    "b-row",
                    { staticClass: "mb-4", attrs: { "align-h": "between" } },
                    [
                      _c("b-col", { attrs: { cols: "auto" } }, [
                        _c("h4", { staticClass: "card-title mb-0" }, [
                          _vm._v(_vm._s(_vm.user.fullName))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "small text-muted" }, [
                          _vm._v("Added " + _vm._s(_vm.getUserAddedDate()))
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12" } },
                        [
                          _c("UserForm", {
                            attrs: { addUser: false, formUser: _vm.user },
                            on: { addOrUpdate: _vm.addOrUpdateUserRecord }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-alert",
                            {
                              attrs: {
                                fade: "",
                                show: _vm.updateUserFailure,
                                variant: "danger"
                              }
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.apiResponseMessage(
                                      _vm.updateUserFailure
                                    )
                                  )
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a2abfdd", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2abfdd","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/EditUser.vue
// module id = 1846
// module chunks = 0